module.exports = __webpack_public_path__ + "img/20190611_153430_040.fea4458b.jpg";